import React from "react"
import { Link } from "gatsby"
import { Row, Col, Button, Spacer } from "@cleartrip/bento/lib"
import { RightArrow } from "@cleartrip/bento-icons/src/components/Icons"
import { ReactComponent as CleartripLogo } from "./icons/cleartrip.svg"
import classNames from "classnames"

const Container = props => (
  <div
    className="m-auto"
    style={{
      maxWidth: props.fluid ? "100%" : "1140px",
      padding: props.fluid ? "0 20px" : "0",
    }}
  >
    {props.children}
  </div>
)

function Header(props) {
  const navClass = classNames("d-flex" ,{
    "hover:bg-slate-dark bb bw-4 bc-slate":props.page !== 'index',
    "c-white hover:c-secondary-400": props.page === 'index'
  })
  const activeNavClass = classNames("d-flex bg-slate-dark bb bw-4 bc-orange")
  return (
    <>
      <div style={{ height: "72px" }}></div>

      <header className="bg-tertiary-500 p-fixed t-0 z-10 w-100p">
        <Container fluid={props.fluid}>
          <Row>
            <Col span={24}>
              <div
                className="flex flex-between flex-middle"
                style={{ height: "72px" }}
              >
                <Link to="/">
                  <CleartripLogo />
                </Link>

                <ul
                  className="flex fs-body c-white flex-middle"
                  style={{ height: "72px", listStyleType: "none" }}
                >
                  <li
                    className={
                      props.activeNav === "Tokens" ? activeNavClass : navClass
                    }
                  >
                    <Link
                      to="/tokens/color"
                      className="td-none c-inherit px-8 py-6"
                    >
                      Tokens
                    </Link>
                  </li>
                  <li
                    className={
                      props.activeNav === "Utilities"
                        ? activeNavClass
                        : navClass
                    }
                  >
                    <Link
                      to="/utilities/background"
                      className="td-none c-inherit px-8 py-6"
                    >
                      Utilities
                    </Link>
                  </li>
                  <li
                    className={
                      props.activeNav === "Components"
                        ? activeNavClass
                        : navClass
                    }
                  >
                    <Link
                      to="/components/badge"
                      className="td-none c-inherit px-8 py-6"
                    >
                      Components
                    </Link>
                  </li>
                  {props.page === "index" ? (
                    <li className="ml-5" style={{minWidth: '120px'}}>
                      <Button
                        appearance="dark"
                        full
                        onClick={() => {
                          window.location.href = "/icons/filled"
                        }}
                        className="flex flex-middle flex-center"
                        size="md"
                        type="secondary"
                        as="a"
                      >
                        <span className="fs-inherit c-inherit fw-inherit">Icons</span>
                         {/* <Spacer className="pr-3" />
                         <RightArrow width={18} /> */}
                      </Button>
                    </li>
                  ) : (
                    <li
                      className={
                        props.activeNav === "Icons"
                          ? activeNavClass
                          : navClass
                      }
                    >
                      <Link
                        to="/icons/filled"
                        className="td-none c-inherit px-8 py-6"
                      >
                        Icons
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </header>
    </>
  )
}

export default Header
